import { TenantProvider } from "providers/TenantProvider/TenantProvider";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { PageOrganization } from "pages/organization/PageOrganization";
import { PageProject } from "pages/project/PageProject";
import { ToolSpecProvider } from "providers/ToolSpecProvider/ToolSpecProvider";
import { Page404 } from "pages/404/Page404";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { OrganizationUsage } from "pages/organization/OrganizationUsage";
import { OrganizationPeople } from "pages/organization/OrganizationPeople";
import { OrgRedirect } from "./OrgRedirect";
import { PageTool } from "pages/tool/PageTool";

export const OrganizationRoutes = () => {
  const routeMap = useRouteMapContext((s) => s.routeMap);
  const { path } = useRouteMatch();

  return (
    <TenantProvider>
      <ToolSpecProvider>
        <Switch>
          <Route
            exact
            path={[
              path,
              routeMap["ORGANIZATION_TOOLS"].parameterizedPath,
              routeMap["ORGANIZATION_CONTAINERS"].parameterizedPath,
            ]}
          >
            <PageOrganization />
          </Route>
          <Route
            exact
            path={[
              routeMap["TOOL"].parameterizedPath,
              routeMap["TOOL_TASKS"].parameterizedPath,
              routeMap["TOOL_FILES"].parameterizedPath,
              routeMap["TOOL_SETTINGS"].parameterizedPath,
              routeMap["TOOL_EDITOR"].parameterizedPath,
            ]}
          >
            <PageTool />
          </Route>
          <Route
            path={[
              routeMap["DATASET"].parameterizedPath,
              routeMap["DATASET_HISTORY"].parameterizedPath,
              routeMap["DATASET_VERSION"].parameterizedPath,
              routeMap["PROJECT_ANALYSIS_TABLE_GROUP"].parameterizedPath,
            ]}
            exact
          >
            <OrgRedirect />
          </Route>
          <Route
            path={[
              routeMap["PROJECT_TABLE"].parameterizedPath,
              routeMap["PROJECT"].parameterizedPath,
              routeMap["PROJECT_FILES"].parameterizedPath,
              routeMap["PROJECT_SETTINGS"].parameterizedPath,
              routeMap["PROJECT_TASKS"].parameterizedPath,
              routeMap["PROJECT_ACCESS"].parameterizedPath,
            ]}
            exact
          >
            <PageProject />
          </Route>

          <Route path={routeMap["ORGANIZATION_USAGE"].parameterizedPath}>
            <OrganizationUsage />
          </Route>
          <Route path={routeMap["ORGANIZATION_PEOPLE"].parameterizedPath}>
            <OrganizationPeople />
          </Route>
          <Route path="*">
            <Page404 />
          </Route>
        </Switch>
      </ToolSpecProvider>
    </TenantProvider>
  );
};
